import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import serviceAgreement from '@/views/serviceAgreement'
import authorization from '@/views/authorization'
import userAgreement from '@/views/userAgreement'
import paymentService from '@/views/paymentService'
import privacyPolicy from '@/views/privacyPolicy'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: "/index",
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: serviceAgreement
    },
    {
      path: '/authorization',
      name: 'authorization',
      component: authorization
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement
    },
    {
      path: '/paymentService',
      name: 'paymentService',
      component: paymentService
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    }
  ]
})

